import api from './client';
import type {
  PwaVariant,
  PwaVariantStats,
  CreateVariantInput,
  UpdateVariantInput,
} from './types';

export function listVariants(pwaId: string): Promise<PwaVariant[]> {
  return api.get<PwaVariant[]>(`/admin/variants/${pwaId}`);
}

export function listVariantStats(pwaId: string): Promise<PwaVariantStats[]> {
  return api.get<PwaVariantStats[]>(`/admin/variants/${pwaId}/stats`);
}

export function createVariant(pwaId: string, input: CreateVariantInput): Promise<PwaVariant> {
  return api.post<PwaVariant>(`/admin/variants/${pwaId}`, input);
}

export function updateVariant(
  pwaId: string,
  variantId: string,
  input: UpdateVariantInput,
): Promise<PwaVariant> {
  return api.patch<PwaVariant>(`/admin/variants/${pwaId}/${variantId}`, input);
}

export function deleteVariant(pwaId: string, variantId: string): Promise<null> {
  return api.delete<null>(`/admin/variants/${pwaId}/${variantId}`);
}

export function promoteVariant(pwaId: string, variantId: string): Promise<null> {
  return api.post<null>(`/admin/variants/${pwaId}/${variantId}/promote`);
}
